import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export const { go, goBack, push, replace } = history;
export default history;
